import { createAction } from 'helpers/actionHelpers/createAction'
import { VideoChannelOptions, PermissionsState } from 'components/features/videoCalls/types/state'
import { AgoraClientEventType, AgoraStreamEventType, AgoraClientId, StreamId, WithStreamId } from 'components/features/videoCalls/types/agoraTypes'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { Stream } from 'agora-rtc-sdk'

type JoinChannelPayload = {
  clientId: AgoraClientId
  localStreamId: StreamId
}
export class AgoraReJoinChannelAction extends createAction<'AGORA_REJOIN_CHANNEL', void>('AGORA_REJOIN_CHANNEL') {}
export class AgoraJoinChannelAction extends createRequestAction<'AGORA_JOIN_CHANNEL', VideoChannelOptions, JoinChannelPayload, void>('AGORA_JOIN_CHANNEL') {}
export class AgoraLeaveChannelAction extends createRequestAction<'AGORA_LEAVE_CHANNEL', void, void, void>('AGORA_LEAVE_CHANNEL') {}

export class AgoraClientEventAction extends createAction<'AGORA_CLIENT_EVENT', AgoraClientEventType>('AGORA_CLIENT_EVENT') {}
export class AgoraStreamEventAction extends createAction<'AGORA_STREAM_EVENT', AgoraStreamEventType>('AGORA_STREAM_EVENT') {}

type WithId = { id: StreamId }
export class AgoraPeerAddedAction extends createAction<'AGORA_PEER_ADDED', WithId>('AGORA_PEER_ADDED') {}
export class AgoraPeerRemovedAction extends createAction<'AGORA_PEER_REMOVED', WithId>('AGORA_PEER_REMOVED') {}

export class AgoraMuteAudioAction extends createRequestAction<'AGORA_MUTE_AUDIO_STREAM', StreamId | null, void, void>('AGORA_MUTE_AUDIO_STREAM') {}
export class AgoraUnmuteAudioAction extends createRequestAction<'AGORA_UNMUTE_AUDIO_STREAM', StreamId | null, void, void>('AGORA_UNMUTE_AUDIO_STREAM') {}
export class AgoraMuteVideoAction extends createRequestAction<'AGORA_MUTE_VIDEO_STREAM', StreamId | null, void, void>('AGORA_MUTE_VIDEO_STREAM') {}
export class AgoraUnmuteVideoAction extends createRequestAction<'AGORA_UNMUTE_VIDEO_STREAM', StreamId | null, void, void>('AGORA_UNMUTE_VIDEO_STREAM') {}

export class AgoraAudioInputAction extends createAction<'AGORA_AUDIO_INPUT', string | null>('AGORA_AUDIO_INPUT') {}
export class AgoraVideoInputAction extends createAction<'AGORA_VIDEO_INPUT', string | null>('AGORA_VIDEO_INPUT') {}

type PublishStreamResponse =
  & WithStreamId
  & {
    videoInputDeviceId: string | null
    audioInputDeviceId: string | null
    isVideoMute: boolean
    isAudioMute: boolean
  }
export class AgoraPublishLocalStream extends createRequestAction<'AGORA_PUBLISH_LOCAL_STREAM', void, PublishStreamResponse, void>('AGORA_PUBLISH_LOCAL_STREAM') {}
export class AgoraUnPublishLocalStream extends createRequestAction<'AGORA_UNPUBLISH_LOCAL_STREAM', void, WithStreamId, void>('AGORA_UNPUBLISH_LOCAL_STREAM') {}

export class AgoraScreenShareAction extends createRequestAction<'AGORA_SCREEN_SHARE_STREAM', { stream: Stream }, JoinChannelPayload, { unavailable?: boolean }>('AGORA_SCREEN_SHARE_STREAM') {}
export class AgoraStopScreenShareAction extends createRequestAction<'AGORA_STOP_SCREEN_SHARE_STREAM', void, WithStreamId, void>('AGORA_STOP_SCREEN_SHARE_STREAM') {}
export class AgoraScreenShareUnavailableAction extends createAction<'AGORA_SCREEN_SHARE_UNAVAILABLE_STREAM', void>('AGORA_SCREEN_SHARE_UNAVAILABLE_STREAM') {}

export class AgoraPinVideoAction extends createAction<'AGORA_PIN_VIDEO_STATE', { streamId: StreamId }>('AGORA_PIN_VIDEO_STATE') {}
export class AgoraUnPinVideoAction extends createAction<'AGORA_UNPIN_VIDEO_STATE', void>('AGORA_UNPIN_VIDEO_STATE') {}


export class AgoraSetActiveSpeakerAction extends createAction<'AGORA_SET_ACTIVE_SPEAKER', StreamId>('AGORA_SET_ACTIVE_SPEAKER') {}

export class UpdateMediaPermissionsAction extends createRequestAction<'UPDATE_MEDIA_PERMISSIONS', void, Partial<PermissionsState>, void>('UPDATE_MEDIA_PERMISSIONS') {}
export class SetMediaPermissionsAction extends createAction<'SET_MEDIA_PERMISSIONS', Partial<PermissionsState>>('SET_MEDIA_PERMISSIONS') {}


export type VideoCallAction =
  | AgoraReJoinChannelAction
  | typeof AgoraJoinChannelAction.Type
  | typeof AgoraLeaveChannelAction.Type

  | AgoraSetActiveSpeakerAction

  | typeof AgoraPublishLocalStream.Type
  | typeof AgoraUnPublishLocalStream.Type

  | typeof AgoraMuteAudioAction.Type
  | typeof AgoraUnmuteAudioAction.Type
  | typeof AgoraMuteVideoAction.Type
  | typeof AgoraUnmuteVideoAction.Type

  | AgoraAudioInputAction
  | AgoraVideoInputAction

  | typeof AgoraScreenShareAction.Type
  | typeof AgoraStopScreenShareAction.Type
  | AgoraScreenShareUnavailableAction
  | AgoraPinVideoAction
  | AgoraUnPinVideoAction

  | AgoraClientEventAction
  | AgoraStreamEventAction
  | AgoraPeerAddedAction
  | AgoraPeerRemovedAction

  | typeof UpdateMediaPermissionsAction.Type
  | SetMediaPermissionsAction


